import { createFileRoute } from '@tanstack/react-router'

import { NnppImportOverviewPage } from '@/src/pages/nnpp/imports/NnppImportOverviewPage'

export const Route = createFileRoute(
  '/nnpp/imports/$importId/documents/$documentId/'
)({
  component: NnppImportOverviewPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
